(function () {
  var BP_SP_MAX = 749;
  var BP_PC_MIN = 990;

  var q = function (selector, context) {
    return (context || document).querySelector(selector);
  };

  var qa = function (selector, context) {
    return Array.prototype.slice.call((context || document).querySelectorAll(selector));
  };

  var perPageFor = function (root) {
    var width = window.innerWidth;
    if (width >= BP_PC_MIN) return Number(root.dataset.perPagePc) || 10;
    if (width <= BP_SP_MAX) return Number(root.dataset.perPageSp) || 12;
    return Number(root.dataset.perPageTb) || 12;
  };

  var splitTags = function (value) {
    return value ? value.split('|').filter(Boolean) : [];
  };

  function initNailList(root) {
    var grid = q('[data-aw-nail-list-grid]', root);
    var pagination = q('[data-aw-nail-list-pagination]', root);
    var countEl = q('[data-aw-nail-list-count]', root);
    var emptyEl = q('[data-aw-nail-list-empty]', root);
    if (!grid) return;

    var cards = qa('.aw-nail-card', grid);
    var sortBy = root.dataset.sortBy === 'display_order' ? 'display_order' : 'published_at';
    var activeTab = 'all';
    var currentPageByTab = { all: 1, favorites: 1 };

    var searchPanel = q('[data-aw-nail-search]');
    var activeType = 'all';
    var activeColor = '';
    var activeDesign = '';

    var scopeStaff = new URL(window.location.href).searchParams.get('staff') || '';

    var listState = window.awListState;
    var stateKey = 'aw-nail-list-state';
    var stateReady = false;
    var detailPaths = listState ? listState.detailPaths(cards) : [];
    if (listState) listState.claimScroll(stateKey);

    var cardHandle = function (card) {
      var favoriteButton = card.querySelector('[data-aw-favorite-button]');
      return favoriteButton ? favoriteButton.dataset.favoriteHandle : '';
    };

    var matchesFilters = function (card) {
      if (scopeStaff && card.dataset.staff !== scopeStaff) return false;
      if (activeType !== 'all' && card.dataset.nailType !== activeType) return false;
      if (activeColor && splitTags(card.dataset.colors).indexOf(activeColor) === -1) return false;
      if (activeDesign && splitTags(card.dataset.designTypes).indexOf(activeDesign) === -1) return false;
      if (activeTab === 'favorites') {
        if (!window.awFavorites || !window.awFavorites.isFavorite('nail', cardHandle(card))) return false;
      }
      return true;
    };

    var sortCards = function () {
      cards.sort(function (a, b) {
        if (sortBy === 'display_order') {
          return Number(a.dataset.displayOrder || 999999) - Number(b.dataset.displayOrder || 999999);
        }
        var aTime = Number(a.dataset.publishedAt || 0);
        var bTime = Number(b.dataset.publishedAt || 0);
        if (aTime !== bTime) return bTime - aTime;
        return Number(b.dataset.legacyWpId || 0) - Number(a.dataset.legacyWpId || 0);
      });
      cards.forEach(function (card) {
        grid.appendChild(card);
      });
      if (emptyEl) grid.appendChild(emptyEl);
    };

    var renderPagination = function (maxPage, currentPage) {
      if (!pagination) return;
      pagination.innerHTML = '';
      if (maxPage <= 1) return;

      var addButton = function (label, page, isActive, isDisabled) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'aw-nail-list__page' + (isActive ? ' aw-nail-list__page--active' : '');
        button.textContent = label;
        button.disabled = !!isDisabled;
        button.setAttribute('aria-current', isActive ? 'page' : 'false');
        button.addEventListener('click', function () {
          currentPageByTab[activeTab] = page;
          render();
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        pagination.appendChild(button);
      };

      addButton('‹', Math.max(1, currentPage - 1), false, currentPage === 1);

      var from = Math.max(1, currentPage - 2);
      var to = Math.min(maxPage, from + 4);
      from = Math.max(1, Math.min(from, to - 4));

      for (var page = from; page <= to; page++) {
        addButton(String(page), page, page === currentPage, false);
      }

      addButton('›', Math.min(maxPage, currentPage + 1), false, currentPage === maxPage);
    };

    var render = function () {
      var perPage = perPageFor(root);
      var visible = cards.filter(matchesFilters);
      var maxPage = Math.max(1, Math.ceil(visible.length / perPage));
      if (currentPageByTab[activeTab] > maxPage) currentPageByTab[activeTab] = maxPage;
      var currentPage = currentPageByTab[activeTab];

      if (countEl) countEl.textContent = String(visible.length);

      var start = (currentPage - 1) * perPage;
      var end = start + perPage;
      var pageItems = visible.slice(start, end);

      cards.forEach(function (card) {
        card.classList.add('is-hidden');
      });
      pageItems.forEach(function (card) {
        card.classList.remove('is-hidden');
      });

      if (emptyEl) {
        emptyEl.hidden = visible.length > 0;
        emptyEl.textContent = activeTab === 'favorites'
          ? 'お気に入りに登録されたネイルがありません。'
          : '該当するネイルデザインがありません。';
      }

      renderPagination(maxPage, currentPage);
      saveState();
    };

    var tabButtons = [];

    var setActiveTab = function (tab) {
      activeTab = tab;
      tabButtons.forEach(function (btn) {
        var isActive = btn.dataset.awNailListTab === tab;
        btn.classList.toggle('aw-nail-list__tab--active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    };

    var initTabs = function () {
      tabButtons = qa('[data-aw-nail-list-tab]', root);
      tabButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          var tab = button.dataset.awNailListTab;
          if (tab === activeTab) return;
          setActiveTab(tab);
          render();
        });
      });
    };

    var setActiveToggle = function (buttons, selectedButton) {
      buttons.forEach(function (button) {
        var isActive = button === selectedButton;
        button.classList.toggle('aw-search-panel__toggle--active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    };

    var addOptions = function (selectEl, values) {
      if (!selectEl) return;
      values.forEach(function (value) {
        var option = document.createElement('option');
        option.value = value;
        option.textContent = value;
        selectEl.appendChild(option);
      });
    };

    var distinctValues = function (field) {
      var seen = {};
      var values = [];
      cards.forEach(function (card) {
        splitTags(card.dataset[field]).forEach(function (value) {
          if (seen[value]) return;
          seen[value] = true;
          values.push(value);
        });
      });
      return values.sort(function (a, b) {
        return a.localeCompare(b, 'ja');
      });
    };

    var initSearchPanel = function () {
      if (!searchPanel) return;

      var typeButtons = qa('[data-nail-type]', searchPanel);
      typeButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          activeType = button.dataset.nailType || 'all';
          setActiveToggle(typeButtons, button);
          currentPageByTab[activeTab] = 1;
          render();
        });
      });

      var colorSelect = q('[data-nail-color-select]', searchPanel);
      var designSelect = q('[data-nail-design-select]', searchPanel);
      addOptions(colorSelect, distinctValues('colors'));
      addOptions(designSelect, distinctValues('designTypes'));

      if (colorSelect) {
        colorSelect.addEventListener('change', function () {
          activeColor = colorSelect.value;
          currentPageByTab[activeTab] = 1;
          render();
        });
      }
      if (designSelect) {
        designSelect.addEventListener('change', function () {
          activeDesign = designSelect.value;
          currentPageByTab[activeTab] = 1;
          render();
        });
      }
    };

    var showScope = function () {
      var scopeEl = q('[data-aw-nail-list-scope]', root);
      var labelEl = scopeEl ? q('[data-aw-nail-list-scope-label]', scopeEl) : null;
      if (!scopeEl || !labelEl || !scopeStaff) return;

      var staffCard = cards.filter(function (card) { return card.dataset.staff === scopeStaff; })[0];
      var name = staffCard ? staffCard.dataset.staffName : '';
      labelEl.textContent = '「' + (name || '指定の条件') + '」で絞り込み中';
      scopeEl.hidden = false;
    };

    var saveState = function () {
      if (!listState || !stateReady) return;
      listState.write(stateKey, {
        scope: scopeStaff,
        type: activeType,
        color: activeColor,
        design: activeDesign,
        tab: activeTab,
        pages: currentPageByTab
      });
    };

    var selectOption = function (selectEl, value) {
      if (!selectEl || !value) return '';
      var exists = qa('option', selectEl).some(function (option) {
        return option.value === value;
      });
      if (!exists) return '';
      selectEl.value = value;
      return value;
    };

    var restoreState = function () {
      if (!listState) return null;
      var touched = activeType !== 'all' || activeColor || activeDesign;
      var loaded = touched ? null : listState.load(stateKey, detailPaths);
      if (!loaded || loaded.state.scope !== scopeStaff) return null;
      var saved = loaded.state;

      if (searchPanel) {
        var typeButtons = qa('[data-nail-type]', searchPanel);
        var typeButton = typeButtons.filter(function (button) {
          return (button.dataset.nailType || 'all') === saved.type;
        })[0];
        if (typeButton) {
          activeType = saved.type;
          setActiveToggle(typeButtons, typeButton);
        }
        activeColor = selectOption(q('[data-nail-color-select]', searchPanel), saved.color);
        activeDesign = selectOption(q('[data-nail-design-select]', searchPanel), saved.design);
      }

      if (saved.tab === 'favorites' || saved.tab === 'all') setActiveTab(saved.tab);
      if (saved.pages && typeof saved.pages === 'object') {
        ['all', 'favorites'].forEach(function (tab) {
          var page = Number(saved.pages[tab]);
          if (page >= 1) currentPageByTab[tab] = Math.floor(page);
        });
      }
      return loaded;
    };

    sortCards();
    initTabs();
    initSearchPanel();
    showScope();
    var restored = restoreState();
    stateReady = true;
    render();
    if (listState) {
      listState.finish(restored);
      window.addEventListener('pagehide', saveState);
      grid.addEventListener('click', function (event) {
        if (event.target.closest('a[href]')) saveState();
      }, true);
      window.addEventListener('pageshow', function (event) {
        if (event.persisted) listState.restoreCached(stateKey, scopeStaff);
      });
    }

    document.addEventListener('aw:favorites-changed', render);
    window.addEventListener('storage', function (event) {
      if (event.key === 'aw-favorites') render();
    });

    var lastPerPage = perPageFor(root);
    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        var perPage = perPageFor(root);
        if (perPage !== lastPerPage) {
          lastPerPage = perPage;
          currentPageByTab[activeTab] = 1;
        }
        render();
      }, 200);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-aw-nail-list]'), initNailList);
  });
})();
